import { LOGIN_TOKEN } from '@/global/constants'
import { MOCK_LOGIN_SESSION_KEY } from './mock-login-session'

interface StorageChange {
  key: string | null
}

export function createMockLoginStorageSync(
  reload: () => void,
  delay = 80
) {
  let reloadTimer: ReturnType<typeof setTimeout> | null = null

  const handleStorage = ({ key }: StorageChange) => {
    if (key !== LOGIN_TOKEN && key !== MOCK_LOGIN_SESSION_KEY) return

    if (reloadTimer) clearTimeout(reloadTimer)
    reloadTimer = setTimeout(() => {
      reloadTimer = null
      reload()
    }, delay)
  }

  const dispose = () => {
    if (reloadTimer) clearTimeout(reloadTimer)
    reloadTimer = null
  }

  return { dispose, handleStorage }
}
